"use stric";
import FilterCarsItems from "./static.filterCarsItems";

const carsStatuses = {
  withInActive: {
    id: -2,
    title: "Показать неактивные ТС",
    name: FilterCarsItems.withInActive.name,
  },
  loss: {
    id: -1,
    title: "Нет данных",
    name: FilterCarsItems.noData.name,
  },
  inmotion: {
    id: 1,
    title: "В движении",
    name: FilterCarsItems.inMove.name,
  },
  parking: {
    id: 0,
    title: "Стоянка",
    name: FilterCarsItems.parking.name,
  },
  fueling: {
    id: 3,
    ...FilterCarsItems.fueling,
  },
  drain: {
    id: 4,
    ...FilterCarsItems.drain,
  },
  gpsJammng: {
    id: 5,
    ...FilterCarsItems.gpsJammng,
  },
  speedingPoints: {
    id: 6,
    ...FilterCarsItems.speedingPoints,
  },
};

export { carsStatuses };
